"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _peractoConfig = require("@peracto/peracto-config");

var _TextInput = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/TextInput"));

var _File = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/File"));

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

var _Slider = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Slider"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _startCase = _interopRequireDefault(require("lodash/startCase"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ButtonsForm = function ButtonsForm(_ref) {
  var _Object$keys, _theme$colors;

  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      buttons = _ref$state.buttons,
      _ref$state$direction = _ref$state.direction,
      direction = _ref$state$direction === void 0 ? 'row' : _ref$state$direction,
      _ref$state$justifyCon = _ref$state.justifyContent,
      justifyContent = _ref$state$justifyCon === void 0 ? 'flex-start' : _ref$state$justifyCon,
      _ref$state$spacing = _ref$state.spacing,
      spacing = _ref$state$spacing === void 0 ? 10 : _ref$state$spacing,
      selectedButtonIndex = _ref$state.selectedButtonIndex;
  var config = (0, _peractoConfig.useConfig)();

  var _ref2 = config.get('editorConfig') || [],
      theme = _ref2.theme,
      buttonVariants = _ref2.buttonVariants,
      isTailwind = _ref2.isTailwind;

  var variantOptions = buttonVariants ? (_Object$keys = Object.keys(buttonVariants)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (variant) {
    return {
      label: (0, _startCase["default"])(variant),
      value: variant
    };
  }) : [];
  var themeColours = [];

  if (theme !== null && theme !== void 0 && (_theme$colors = theme.colors) !== null && _theme$colors !== void 0 && _theme$colors.brand) {
    for (var _i = 0, _Object$entries = Object.entries(theme.colors.brand); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          label = _Object$entries$_i[0],
          colour = _Object$entries$_i[1];

      themeColours.push({
        label: (0, _startCase["default"])(label),
        value: colour
      });
    }
  }

  var DEFAULT_BUTTON = {
    label: 'Click Me',
    colour: '#000',
    textColour: '#FFF',
    url: '#',
    openInNewTab: false,
    size: 'md',
    style: 'solid',
    variant: 'primary',
    width: 'auto',
    isDark: false
  };
  var JUSTIFICATION_OPTIONS = [{
    label: 'Start',
    value: 'flex-start'
  }, {
    label: 'Centre',
    value: 'center'
  }, {
    label: 'End',
    value: 'flex-end'
  }];

  if (direction === 'row') {
    JUSTIFICATION_OPTIONS.push({
      label: 'Space Between',
      value: 'space-between'
    }, {
      label: 'Space Around',
      value: 'space-around'
    });
  }

  (0, _react.useEffect)(function () {
    return function () {
      _onChange({
        selectedButtonIndex: null
      });
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Buttons Direction",
    options: [{
      label: 'Row',
      value: 'row'
    }, {
      label: 'Column',
      value: 'column'
    }],
    value: direction,
    onChange: function onChange(e) {
      return _onChange({
        direction: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Justify Buttons",
    options: JUSTIFICATION_OPTIONS,
    value: justifyContent,
    onChange: function onChange(e) {
      return _onChange({
        justifyContent: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "Button Spacing",
    min: 0,
    max: 30,
    step: 1,
    value: spacing,
    onChange: function onChange(e) {
      return _onChange({
        spacing: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("hr", null), selectedButtonIndex !== null && buttons && buttons[selectedButtonIndex] && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Button Label",
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].label = e.target.value;

      _onChange({
        buttons: buttonsClone
      });
    },
    value: buttons[selectedButtonIndex].label
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Button Link",
    onChange: function onChange(value) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].url = value;

      _onChange({
        buttons: buttonsClone
      });
    },
    value: buttons[selectedButtonIndex].url
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Open in new tab",
    checked: buttons[selectedButtonIndex].openInNewTab,
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].openInNewTab = e.target.checked;

      _onChange({
        buttons: buttonsClone
      });
    }
  }), (variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Button Variant",
    options: variantOptions,
    value: buttons[selectedButtonIndex].variant,
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].variant = e.value;

      _onChange({
        buttons: buttonsClone
      });
    }
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Button Colour",
    options: [].concat(themeColours),
    value: buttons[selectedButtonIndex].colour,
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].colour = e.value;

      _onChange({
        buttons: buttonsClone
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Text Colour",
    options: [{
      label: 'White',
      value: '#fff'
    }, {
      label: 'Black',
      value: '#000'
    }].concat(themeColours),
    value: buttons[selectedButtonIndex].textColour,
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].textColour = e.value;

      _onChange({
        buttons: buttonsClone
      });
    }
  }), !isTailwind && /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Button Size",
    options: [{
      label: 'Extra Small',
      value: 'xs'
    }, {
      label: 'Small',
      value: 'sm'
    }, {
      label: 'Medium',
      value: 'md'
    }, {
      label: 'Large',
      value: 'lg'
    }],
    value: buttons[selectedButtonIndex].size,
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].size = e.value;

      _onChange({
        buttons: buttonsClone
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Button Style",
    options: [{
      label: 'Solid',
      value: 'solid'
    }, {
      label: 'Outline',
      value: 'outline'
    }, {
      label: 'Link',
      value: 'link'
    }],
    value: buttons[selectedButtonIndex].style,
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].style = e.value;

      _onChange({
        buttons: buttonsClone
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Button Width",
    options: [{
      label: 'Auto',
      value: 'auto'
    }, {
      label: 'Full',
      value: 'full'
    }],
    value: buttons[selectedButtonIndex].width || 'auto',
    onChange: function onChange(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone[selectedButtonIndex].width = e.value;

      _onChange({
        buttons: buttonsClone
      });
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-danger w-100 mt-2",
    onClick: function onClick(e) {
      var buttonsClone = _toConsumableArray(buttons);

      buttonsClone.splice(selectedButtonIndex, 1);

      _onChange({
        buttons: buttonsClone
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash,
    className: "mr-2"
  }), " Remove Button")), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "my-2"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-secondary w-100",
    onClick: function onClick(e) {
      var buttonsClone = [].concat(_toConsumableArray(buttons), [DEFAULT_BUTTON]);

      _onChange({
        buttons: buttonsClone
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlusCircle.faPlusCircle,
    className: "mr-2"
  }), " Add Button"));
};

var _default = ButtonsForm;
exports["default"] = _default;